import React from 'react';
import { Box, Typography, IconButton, Avatar, Menu, MenuItem, Tooltip } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import NotificationBell from '../components/NotificationBell';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';

const AppBar = ({ pageTitle, sidebarOpen, onToggleSidebar }) => {
    const { user, logout } = useAuth();
    const theme = useTheme();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    const handleProfileClick = () => {
        handleMenuClose();
        navigate('/profile');
    };

    return (
        <Box
            sx={{
                width: sidebarOpen ? `calc(100% - ${theme.sidebar.width}px)` : '100%',
                ml: sidebarOpen ? `${theme.sidebar.width}px` : 0,
                bgcolor: theme.palette.header.bg,
                px: 4,
                py: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: '1px solid',
                borderColor: 'divider',
                position: 'fixed',
                zIndex: theme.zIndex.appBar,
                top: 0,
                left: 0,
                transition: theme.transitions.create(['margin', 'width'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Tooltip title={sidebarOpen ? 'Hide Sidebar' : 'Show Sidebar'}>
                    <IconButton
                        onClick={onToggleSidebar}
                        sx={{
                            color: theme.palette.text.primary,
                        }}
                    >
                        {sidebarOpen ? <MenuOpenIcon /> : <MenuIcon />}
                    </IconButton>
                </Tooltip>
                <Typography
                    variant="h4"
                    sx={{
                        color: theme.palette.text.primary,
                        fontWeight: 700,
                        fontFamily: theme.typography.fontFamily,
                    }}
                >
                    {pageTitle}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <NotificationBell />
                <IconButton
                    onClick={handleMenuOpen}
                    size="small"
                    sx={{
                        width: 32,
                        height: 32,
                        '& .MuiAvatar-root': {
                            width: 24,
                            height: 24,
                        }
                    }}
                >
                    <Avatar
                        src={user?.avatarUrl}
                        sx={{
                            width: 24,
                            height: 24,
                            fontSize: '0.875rem'
                        }}
                    />
                </IconButton>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                >
                    <MenuItem onClick={handleProfileClick}>Profile</MenuItem>
                    <MenuItem onClick={logout}>Logout</MenuItem>
                </Menu>
            </Box>
        </Box>
    );
};

export default AppBar; 